import { Loader } from '@/shared/ui/loader'

import type { FC } from 'react'

import type { PageLoaderProps } from './PageLoader.types'

/**
 * PageLoader - Simple centered loading component for pages.
 *
 * Displays a centered loader with a minimum height to provide a smooth loading experience.
 * Designed to be used as a Suspense fallback for any page layout.
 *
 * @example
 * // Simple usage
 * <Suspense fallback={<Page.Loader />}>
 *   <ActualPage />
 * </Suspense>
 *
 * @example
 * // With custom size
 * <Suspense fallback={<Page.Loader size="lg" />}>
 *   <ActualPage />
 * </Suspense>
 */
export const PageLoader: FC<PageLoaderProps> = ({ size = 'lg' }) => {
  return (
    <div className="page-loader">
      <div className="page-loader-content">
        <Loader size={size} />
      </div>
    </div>
  )
}
